import React, { Component } from "react";
import { Modal, message } from "antd";
import axios from "axios";
import SelectAlumnosItem from "../../../../../Components/SelectAlumnosItem";
import { ButtonItem } from "../../../../../Components/Items";

// Modal para vincular a otro alumno como hermano del cliente actual.
// El vínculo es recíproco. Avisa al padre vía `onSuccess` para que recargue
// la lista de hermanos.
class ModalAgregarHermano extends Component {
  state = {
    hermanoSeleccionado: null,
    guardando: false,
  };

  componentDidUpdate(prevProps) {
    // Al cerrarse el modal limpiamos la selección para la próxima apertura.
    if (prevProps.visible && !this.props.visible) {
      this.setState({ hermanoSeleccionado: null });
    }
  }

  vincularHermano = async () => {
    const { hermanoSeleccionado } = this.state;
    if (!hermanoSeleccionado) return;
    const { empresaId, headersToken, clienteId } = this.props;
    this.setState({ guardando: true });
    try {
      const res = await axios.post(
        "clientes/vincularHermano",
        {
          empresaId,
          clienteId,
          hermanoClienteId: hermanoSeleccionado,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success("Hermano vinculado");
        this.setState({ hermanoSeleccionado: null });
        if (this.props.onSuccess) await this.props.onSuccess();
      } else {
        message.warning(res.data.message || "No se pudo vincular el hermano");
      }
    } catch (e) {
      message.error("Error al vincular el hermano");
    } finally {
      this.setState({ guardando: false });
    }
  };

  render() {
    const { visible, empresaId, headersToken, escuelaId, clienteId, onCancel } =
      this.props;
    const { hermanoSeleccionado, guardando } = this.state;

    return (
      <Modal
        title="Agregar hermano"
        visible={visible}
        onCancel={onCancel}
        footer={
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
          >
            <ButtonItem danger onClick={onCancel}>
              Cancelar
            </ButtonItem>
            <ButtonItem
              type="primary"
              onClick={this.vincularHermano}
              loading={guardando}
              disabled={!hermanoSeleccionado}
            >
              Agregar
            </ButtonItem>
          </div>
        }
      >
        <p style={{ marginBottom: 8 }}>
          Busca al alumno que quieres vincular como hermano (por nombre o
          matrícula). El vínculo es recíproco.
        </p>
        <SelectAlumnosItem
          empresaId={empresaId}
          headersToken={headersToken}
          escuelaId={escuelaId}
          excluirClienteId={clienteId}
          value={hermanoSeleccionado}
          onChange={(value) => this.setState({ hermanoSeleccionado: value })}
          placeholder="Buscar alumno por nombre o matrícula"
          style={{ width: "100%" }}
        />
      </Modal>
    );
  }
}

export default ModalAgregarHermano;
